<div class="choose-plan-section">
    <div class="choose-plan-header" *ngIf="showHeading">
        <div class="choose-plan-heading">
            {{ (hasTrialExpired ? 'GUIDED_SETUP.CHOOSE_PLAN.HEADING_TRIAL_EXPIRED' : 'GUIDED_SETUP.CHOOSE_PLAN.HEADING') | translate }}
        </div>
        <!-- Desktop: one row of three check-marked lines. Phone (Figma
             19874-88110): no check icons, "Free until..." on its own line,
             the other two side by side. -->
        <div class="choose-plan-trust">
            <div class="trust-row">
                <div class="trust-item">
                    <ng-icon name="heroCheckCircle" [strokeWidth]="'2'"></ng-icon>
                    <span>{{ 'GUIDED_SETUP.CHOOSE_PLAN.FREE_UNTIL_TRIAL_ENDS' | translate }}</span>
                </div>
            </div>
            <div class="trust-row">
                <div class="trust-item">
                    <ng-icon name="heroCheckCircle" [strokeWidth]="'2'"></ng-icon>
                    <span>{{ 'GUIDED_SETUP.CHOOSE_PLAN.TRUSTED_BY' | translate }}</span>
                </div>
                <div class="trust-item">
                    <ng-icon name="heroCheckCircle" [strokeWidth]="'2'"></ng-icon>
                    <span>{{ 'GUIDED_SETUP.CHOOSE_PLAN.SECURE_CHECKOUT' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="choose-plan-interval" *ngIf="showIntervalToggle">
        <div class="interval-option" role="button" tabindex="0" (click)="selectInterval(SubscriptionInterval.Monthly)" (keydown.enter)="selectInterval(SubscriptionInterval.Monthly)"
            [ngClass]="{'selected': selectedInterval === SubscriptionInterval.Monthly}" [dataHook]="'interval-monthly'">
            {{ 'GUIDED_SETUP.CHOOSE_PLAN.PAY_MONTHLY' | translate }}
        </div>
        <div class="interval-option" role="button" tabindex="0" (click)="selectInterval(SubscriptionInterval.Yearly)" (keydown.enter)="selectInterval(SubscriptionInterval.Yearly)"
            [ngClass]="{'selected': selectedInterval === SubscriptionInterval.Yearly}" [dataHook]="'interval-yearly'">
            {{ 'GUIDED_SETUP.CHOOSE_PLAN.PAY_ANNUALLY' | translate }}
            <span class="interval-badge">{{ 'GUIDED_SETUP.CHOOSE_PLAN.TWO_MONTHS_FREE' | translate }}</span>
        </div>
    </div>
    <rosie-subscription-plans-checkout #checkoutRef [isOnboardingLayout]="true" [hideIntervalToggle]="true"
        [recommendedPlan]="effectiveRecommendedPlan" (planSelected)="onPlanSelected($event)"></rosie-subscription-plans-checkout>
</div>
